/**
 *
 * @param evaluationGrid evaluation grid or evaluation grid template
 * @returns Evaluation grid with their fields sorted
 */
export function sortEvaluationGridFields(evaluationGrid) {
  if (!evaluationGrid || !evaluationGrid.fields || evaluationGrid.fields.length === 0) {
    return evaluationGrid;
  }

  const fields = evaluationGrid.fields.sort((a, b) => {
    const aPinned = a.priority === 'HIGH' ? 0 : 1;
    const bPinned = b.priority === 'HIGH' ? 0 : 1;
    if (aPinned !== bPinned) return aPinned - bPinned;
    return (a.order ?? 0) - (b.order ?? 0);
  });

  return {
    ...evaluationGrid,
    fields,
  };
}
